/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Headline_4Inputs */

const et_hero_headline_4 = /** @type {(inputs: Hero_Headline_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`päevaga,`)
};

const en_hero_headline_4 = /** @type {(inputs: Hero_Headline_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`days,`)
};

/**
* | output |
* | --- |
* | "days," |
*
* @param {Hero_Headline_4Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_headline_4 = /** @type {((inputs?: Hero_Headline_4Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Headline_4Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_headline_4(inputs)
	return en_hero_headline_4(inputs)
});